<template>
  <div class="bannerBox">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(image, index) in images" :key="index" @click="goLink(image)">
          <img :src="image.banner" alt="Image" class="slide-image" />
          <div class="info">
            <!-- <div class="tags" v-if="image.tag">
              {{ image.tag }}
            </div> -->
            <div class="txt">
              <p class="t1 __line2">{{ image.title }}</p>
              <!-- <p class="t2 __line2">{{ image.material_desc }}</p> -->
            </div>
          </div>
          <div class="mask">
            <img src="@/assets/images/mask.png" alt="" />
          </div>
        </div>
      </div>



    </div>
    <!-- 分页器 -->
    <div class="swiper-pagination" v-if="images.length > 1"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";
import { Toast } from "vant";
export default {
  props: {
    type: {
      type: [String, Number],
      default: 1
    }

  },
  data() {
    return {
      swiper: null,
      images: [
        { img: "https://br-education.oss-cn-beijing.aliyuncs.com/learning/20240620/rc-upload-1718862993329-3.jpeg" },
        { img: "https://br-education.oss-cn-beijing.aliyuncs.com/learning/20240620/rc-upload-1718862993329-3.jpeg" },
        { img: "https://br-education.oss-cn-beijing.aliyuncs.com/learning/20240620/rc-upload-1718862993329-3.jpeg" },
        // 添加更多图片路径
      ],
      registerData: null,
    };
  },
  mounted() {
    this.$nextTick(async () => {
      await this.getBannerList();
      if (this.images.length < 2) return;
      this.initSwiper();
    });
  },
  destroyed() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  },

  methods: {
    goLink(item) {
      if (item.url){
        this.$dataStatistics('click', 'banner:' + item.url);
        window.location.href = item.url;
      } 
    },

    nextPageHandle(item) {
      this.isUserRegister(item);
      console.log("item", item);
      this.$dataStatistics(
        { event_type: "click", page_title: "banner" },
        JSON.stringify({ type: `${item.type}`, id: item.id })
      );
    },
    async getBannerList() {
      let params = {
        'filter[type]': this.type
      }
      let { data } = await this.$http.get("/api/platform/banner", { params });
      console.log("data", data);
      this.images = data;
    },
    initSwiper() {
      this.swiper = new Swiper(".swiper-container", {
        loop: true,
        autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.swiper-container {
  border-radius: 8px;
  width: 100%;
  height: 100%;
  margin-top: 22px;
  // box-shadow: 0 12px 26px rgba(0, 0, 0, 0.26);
}

.mask {
  z-index: 1;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 198px;
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
  }
}

.slide-image {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.swiper-pagination-bullets {
  bottom: -26px;
  margin: 0 auto;
  left: 0;
  right: 0;
}

::v-deep .swiper-pagination-bullet {
  width: 6px !important;
  height: 6px !important;
  background: rgba(16, 16, 16, 0.1);
  opacity: 1;
  margin: 0 8px !important;
}

.bannerBox {
  width: 100%;
  height: 100%;
  position: relative;

  .info {
    padding: 0 16px;
    position: relative;
    z-index: 22;
    margin-bottom: 15px;

    .tags {
      display: inline-block;
      padding: 4px 6px;
      line-height: 18px;
      text-align: center;
      background: #0059A3;
      border-radius: 4px;
      margin-bottom: 8px;
      color: #F3F3F3;
    }

    .txt {
      .t1 {
        font-size: 16px;
        color: #FFFFFF;
        font-weight: bold;
      }

      .t2 {
        font-size: 14px;
        color: #F3F3F3;
        margin-top: 6px;
      }
    }
  }
}

.swiper-slide {
  display: flex;
  align-items: flex-end;

}

::v-deep .swiper-pagination-bullet-active {
  width: 32px !important;
  height: 6px !important;
  background: #0059A3;
  border-radius: 26px;
  opacity: 1;
  transition: all 0.3s;
}</style>